import { MainFrame } from "@/common/MainFrame";
import { Outlet } from "react-router-dom";

export function ModuleCalendarToIncomeStatement() {
    return <MainFrame>
        <Outlet/>
    </MainFrame>;
}
